import { Component } from '@angular/core';
import { GenericSliderPage } from '@uigy/shared/components/slider-v2/models/generic-slider-page';
import { LanguageService } from '@uigy/shared/services/language.service';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { FormValidatorsService } from '@uigy/shared/services/form-validators.service';

@Component({
    selector: 'app-activation-code-dialog',
    templateUrl: './activation-code-dialog.component.html',
    standalone: false
})
export class ActivationCodeDialogComponent implements GenericSliderPage<void, { code: string }> {
  public form = new UntypedFormGroup({
    code: new UntypedFormControl(undefined, Validators.required),
  });

  public dialogTexts = this.languageService.texts.license_activation.step3.slider;

  constructor(private languageService: LanguageService, public formValidatorsService: FormValidatorsService) { }

  getData(): {code: string} {
    return this.form.value;
  }

  initData(data: void | undefined): void {
  }

  isValid(): boolean {
    return this.form.valid;
  }
}
